"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.italyTranslations = void 0;
var _types = require("../../../types");
const italyTranslations = exports.italyTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Mi dispiace tanto!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Indietro',
  [_types.ErrorPageTranslationKey.text]: 'Questa pagina per il momento non è disponibile',
  [_types.ErrorPageTranslationKey.notFound]: 'La pagina che stai cercando non è disponibile',
  [_types.ErrorPageTranslationKey.unauthorized]: 'La pagina che stai tentando di raggiungere è limitata e non sono stati soddisfatti tutti i criteri.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Si prega di contattare il team di supporto Oriflame tramite e-mail:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: "L'URL richiesto è stato rifiutato!"
};
